import styled from "styled-components";
import { FC } from "react";
import { BaseComponentProps } from "../types";
import { Icon } from "../Icon/Icon";
import { alpha } from "../../typography";

export enum BreadcrumbItemTestIds {
  Container = "breadcrumb-item",
}

const Link = styled.a`
  ${alpha.link.body3};
  margin-right: 8px;
  &:focus {
    outline-offset: 3px;
  }
  &:visited {
    color: var(--color-secondary-800);
  }

  &:hover {
    color: var(--color-secondary-600);
  }
`;

type BaseBreadcrumbsItemType = {
  className?: string;
  id?: string;
  testId?: string;
  isCurrentPage?: boolean;
};

const BaseBreadcrumbsItem = styled.li<BaseBreadcrumbsItemType>`
  display: flex;
  & > span {
    margin-right: 8px;
    ${(props) =>
      props.isCurrentPage ? alpha.primaryActive.body3 : alpha.link.body3};
  }
`;

type BreadcrumbsItemProps = BaseComponentProps<"li"> &
  BaseBreadcrumbsItemType & {
    href?: string;
  };

export const BreadcrumbsItem: FC<BreadcrumbsItemProps> = ({
  children,
  className,
  href,
  id,
  isCurrentPage = false,
  testId,
}) => {
  let content = children;

  if (typeof content === "string") {
    if (href && !isCurrentPage) {
      content = <Link href={href}>{children}</Link>;
    } else {
      content = <span>{children}</span>;
    }
  }

  return (
    <BaseBreadcrumbsItem
      className={className}
      id={id}
      data-testid={testId ?? BreadcrumbItemTestIds.Container}
      isCurrentPage={isCurrentPage}
    >
      {content}
      {!isCurrentPage && (
        <Icon iconName="chevron-right" iconSize="small" plain />
      )}
    </BaseBreadcrumbsItem>
  );
};
